import type { IVisualizationHeaderProps } from '@/lib/api/types/loop-visualization';
import { useUpdateTimelineHeaderOrderMutation } from '@/lib/mutations/loop-visualization/useTimelineLayoutMutations';
import { useTimelineHeaderConfig } from '@/lib/queries/loop-visualization/useTimelineHeaderConfig';
import { ReorderHeadersDialog } from '../shared/reorder-headers/ReorderHeadersDialog';
import { useViewContext } from '../ViewContext';

interface ReorderTimelineHeadersDialogProps {
  isOpen: boolean;
  onClose: () => void;
  headers: IVisualizationHeaderProps[];
  headerFieldId: string;
  parentFieldId: string | null;
  parentHeaderId: string | null;
  visualizationId: number;
}

export const ReorderTimelineHeadersDialog = ({
  isOpen,
  onClose,
  headerFieldId,
  headers,
  parentFieldId,
  parentHeaderId,
  visualizationId,
}: ReorderTimelineHeadersDialogProps) => {
  const { viewId } = useViewContext();

  const { data: headerConfig } = useTimelineHeaderConfig({
    viewId,
    visualizationId,
    headerFieldId,
    parentFieldId,
    parentHeaderId,
  });

  const { mutateAsync, isPending } = useUpdateTimelineHeaderOrderMutation(viewId, visualizationId);

  return (
    <ReorderHeadersDialog
      isOpen={isOpen}
      onClose={onClose}
      headers={headers}
      headerFieldId={headerFieldId}
      parentFieldId={parentFieldId}
      parentHeaderId={parentHeaderId}
      orderedHeaderIds={headerConfig?.orderedHeaderIds}
      isPending={isPending}
      onSaveOrder={mutateAsync}
    />
  );
};
